"use client";

import { Component, MouseEventHandler, CSSProperties } from "react";
import classNames from "classnames";

/*
BIG NOTE: make sure the classNames in flaticon.css say 'flaticon_flaticon-'!!!!
*/
// import "./styles/FlatIcons.module.scss"

interface IFlatIconProps {
  name: string;
  className?: string;
  ariaHidden?: boolean;
  onClick?: MouseEventHandler<HTMLSpanElement>;
  title?: string;
  style?: CSSProperties;
}

export default class FlatIcon extends Component<IFlatIconProps> {
  static defaultProps = {
    onClick: () => {},
    style: {},
  };

  render() {
    const iconClassName = classNames({
      [this.props.name]: true,
      [this.props.className ?? ""]: this.props.className,
    });

    return (
      <span
        onClick={this.props.onClick}
        aria-hidden={this.props.ariaHidden}
        className={iconClassName}
        title={this.props.title}
        style={this.props.style}
      />
    );
  }
}
